import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ras-date',
	templateUrl: './date.component.html',
	styleUrls: ['./date.component.sass']
})
export class DateComponent implements OnInit {

	public months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
	public view_date: Date = null
	public show_calendar = false
	public view_month: number[][]

	@Input() invalid: boolean = false
	@Input() min_date: Date = null

	public _date: Date | undefined
	@Input() set date(value: Date | undefined) {
		this._date = value
		this.date_str = (value === undefined) ? '' : value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate()
	}
	@Output() dateChange = new EventEmitter<Date>()

	public date_str: string

	public changed(value: string) {
		let date = new Date(value)
		if (isFinite(date.getTime())) {
			this._date = date
			this.dateChange.emit(this._date)
		}
	}

	show_month(year, month) {
		let now = new Date()
		this.view_date = new Date(year, month, 1)

		let view_year = this.view_date.getFullYear()
		let view_month = this.view_date.getMonth()
		let now_year = now.getFullYear()
		let now_month = now.getMonth()
		let now_date = now.getDate()

		let old_month = (view_year < now_year) || (view_year == now_year && view_month < now_month)

		this.view_date = new Date(year, month, 1)

		let today_timestamp = (new Date(now.getFullYear(), now.getMonth(), now.getDate())).getTime()
		let view_timestamp = this.view_date.getTime()
		let day_difference = (view_timestamp - today_timestamp) / (1000*60*60*24)

		let min_offset = 0
		if (this.min_date) {
			let min_date_timestamp = (new Date(this.min_date.getFullYear(), this.min_date.getMonth(), this.min_date.getDate())).getTime()
			min_offset = Math.max(min_offset, (min_date_timestamp - today_timestamp) / (1000*60*60*24))
		}

		this.view_month = []
		let current_week = [null, null, null, null, null, null, null]
		this.view_month.push(current_week)
		let day_index = this.view_date.getDay()
		let last_date = new Date(year, month + 1, 0).getDate()
		for (let i = 1; i <= last_date; i += 1) {
			if (day_index > 6) {
				day_index = 0
				current_week = [null, null, null, null, null, null, null]
				this.view_month.push(current_week)
			}
			current_week[day_index] = (
				(day_difference + i - 1) < min_offset || (day_difference + i - 1) > 90
			) ? -i : i

			day_index += 1
		}
	}

	open_calendar() {
		this.show_calendar = true
		if (this._date != null) this.show_month(this._date.getFullYear(), this._date.getMonth())
		else if (this.min_date && this.min_date.getTime() > (new Date()).getTime()) {
			this.show_month(this.min_date.getFullYear(), this.min_date.getMonth())
		}
		else {
			let now = new Date()
			this.show_month(now.getFullYear(), now.getMonth())
		}
	}

	format(date) {
		return (date == null) ? "" : ( date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear() )
	}

	select_date(date) {
		if (date > 0) {
			let selected_date = new Date(this.view_date.getFullYear(), this.view_date.getMonth(), date, 2)
			let now = new Date()
			let cutoff_date = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			if (this.min_date) {
				let min_date_only = new Date(this.min_date.getFullYear(), this.min_date.getMonth(), this.min_date.getDate())
				if (min_date_only.valueOf() > cutoff_date.valueOf()) cutoff_date = min_date_only
			}
			if (selected_date.valueOf() >= cutoff_date.valueOf()) {
				this._date = selected_date
				this.dateChange.emit(selected_date)
				this.show_calendar = false
			}
		}
	}

	constructor() {
		// this.open_calendar()
	}

	ngOnInit() {
	}

}
